import {buyeeUrl} from "utils/url";

const Trends = () => {
  const trends = [
    {
      name: '鬼滅之刃',
      imageUrl: 'https://cdnyauction.buyee.jp/images.auctions.yahoo.co.jp/image/dr000/auc0304/users/ba897d462fd785f23a02f55c163ca11c91cc2b3f/i-img898x1198-16496809673jeygz26700.jpg',
      linkUrl: buyeeUrl('item/search/query/%E9%AC%BC%E6%BB%85%E4%B9%8B%E5%88%83?translationType=2&page=1&rc=twy_cobrand_entry&twTran=1')
    },
    {
      name: '吉伊卡哇',
      imageUrl: 'https://cdnyauction.buyee.jp/images.auctions.yahoo.co.jp/image/dr000/auc0103/user/77a1d14754634015b1cc8cf6f17cb981bf75da17a2744f5e311f216033c2480b/i-img1200x1083-1742766418135461rhcmpz22.jpg',
      linkUrl: buyeeUrl('item/search/query/%E5%90%89%E4%BC%8A%E5%8D%A1%E5%93%87/category/2084020100?translationType=98')
    },
    {
      name: 'Tomica',
      imageUrl: 'https://cdnyauction.buyee.jp/images.auctions.yahoo.co.jp/image/dr000/auc0304/users/41768d410c331ccbfea72e2ad7d7e37a41060a0b/i-img1200x877-1649746860i25zeq7786.jpg',
      linkUrl: buyeeUrl('item/search/query/%E3%83%88%E3%83%9F%E3%82%AB?searchHis=1')
    },
    {
      name: 'pokemon',
      imageUrl: 'https://cdnyauction.buyee.jp/images.auctions.yahoo.co.jp/image/dr000/auc0405/users/9448298648bbfb0a529b40d9deed3f1a4c0ec7d1/i-img1200x1200-1684221125ckhvw9376505.jpg',
      linkUrl: buyeeUrl('item/search/query/pokemon?translationType=1')
    },
    {
      name: 'Gundam',
      imageUrl: 'https://cdnyauction.buyee.jp/images.auctions.yahoo.co.jp/image/dr000/auc0405/users/7bae327eab9ba7262f70e3589227da28d9114fc3/i-img1062x1200-1684112916q7bnm6825595.jpg',
      linkUrl: buyeeUrl('item/search/query/Gundam?translationType=1')
    },
    {
      name: 'vivienne westwood',
      imageUrl: 'https://cdnyauction.buyee.jp/images.auctions.yahoo.co.jp/image/dr000/auc0405/users/9cd7bb8f76d16b651d1612c8803bb2fdae99db72/i-img600x450-1684029591s4ckva104690.jpg',
      linkUrl: buyeeUrl('item/search/query/vivienne%20westwood?translationType=1')
    },
    {
      name: 'YOASOBI',
      imageUrl: 'https://cdnyauction.buyee.jp/images.auctions.yahoo.co.jp/image/dr000/auc0101/user/b85c906644d70973b099ee5c01d5112e02d1b0de7d3610c143bb67ac65c61b78/i-img1200x1200-17366100612205xazkuz717806.jpg',
      linkUrl: buyeeUrl('item/search/query/yoasobi/category/2084005055?translationType=98')
    },
    {
      name: 'Hermes',
      imageUrl: 'https://cdnyauction.buyee.jp/images.auctions.yahoo.co.jp/image/dr000/auc0108/user/b05ed939061830e2505c6277d45d093817bce22a5d22b6d8c2e3a9892f6fd596/i-img1200x1200-1755499280842797px3035.jpg',
      linkUrl: buyeeUrl('item/search/query/HERMES/category/2084048598?translationType=98')
    },
    {
      name: 'VENDOME AOYAMA',
      imageUrl: 'https://cdnyauction.buyee.jp/images.auctions.yahoo.co.jp/image/dr000/auc0104/user/70f6935b9b89525307b7be287b609da9768663ad00b5a164996635deb32566fd/i-img1200x1200-174386803440056qz1sd71662.jpg',
      linkUrl: buyeeUrl('item/search/query/VENDOME%20AOYAMA/category/23140?translationType=98')
    },
    {
      name: 'hysteric glamour',
      imageUrl: 'https://cdnyauction.buyee.jp/images.auctions.yahoo.co.jp/image/dr000/auc0405/users/9f24139d312de8e4c240d54c0715bcc814bfd5d5/i-img600x450-1684050589bxgnqd803228.jpg',
      linkUrl: buyeeUrl('item/search/query/hysteric%20glamour?translationType=1')
    }
  ];

  return (
    <section id="tw-trending" className="tw-about__list tw-about__list--recommend clearfix">
      <h3 className="title__product-list">話題熱搜</h3>
      <ul className="product-list">
        {trends.map((trend, i) =>
          <li className="item" key={i}>
            <a href={trend.linkUrl} target="_blank">
              <div className="item__img">
                <img className="product-img" src={trend.imageUrl}/>
              </div>
              <div className="item__name item__name--recommend">{trend.name}</div>
            </a>
          </li>
        )}
      </ul>
    </section>
  );
};

export default Trends;
